import React, { useEffect, useRef, useState } from "react";
import { GetOtp, GetOtpVerify, signUpNewUser } from "../apis/Api";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Model = ({ setToken, step, setStep }) => {
  const modalRef = useRef(null);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [error, setError] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [token, setLocalToken] = useState(localStorage.getItem("token"));
  const [showReferralInput, setShowReferralInput] = useState(false);
  const [userData, setUserData] = useState({
    f_name: "",
    l_name: "",
    cust_alt_contact: "",
    cust_email: "",
    referer_code: "",
  });

  const validateFields = () => {
    const requiredFields = ["f_name", "l_name"];

    for (let key of requiredFields) {
      if (userData[key].trim() === "") {
        toast.error(`Please enter ${key.replace(/_/g, " ")}`);
        return false;
      }
    }

    return true;
  };

  const closeModal = () => {
    if (modalRef.current) {
      modalRef.current.click();
    }
  };
  const [timer, setTimer] = useState(30);
  const otpInputRefs = useRef([]);

  useEffect(() => {
    const handleStorageChange = () => {
      const storedToken = localStorage.getItem("token");
      setLocalToken(storedToken);
      if (setToken) setToken(storedToken);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [setToken]);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleChange = (e, index) => {
    let value = e.target.value;
    if (!/^\d?$/.test(value)) return;

    let newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      otpInputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && !otp[index]) {
      otpInputRefs.current[index - 1].focus();
    }
  };

  const sendOtp = async () => {
    if(!phone){
      toast.error("Please Enter Your Mobile Number.");
      return;
    }
    if (!isChecked) {
      toast.error("Please accept the terms & conditions.");
      return;
    }

    try {
      const response = await GetOtp(phone);
      console.log("API Response:", response);

      if (response && response.status == "200") {
        toast.success(response.message || "OTP sent successfully!");
        setStep(2);
      } else {
        toast.error(response?.message || "Failed to send OTP.");
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err.message || "Error sending OTP. Please try again later.");
    }
  };

  const verifyOtp = async () => {
    try {
      const newOtp = otp.join("");
      const response = await GetOtpVerify(phone, newOtp);
      if (!response) throw new Error("No response from server");

      if (response.status == "200") {
        toast.success(response.message || "OTP verified successfully!");
        setOtp(new Array(6).fill(""));

        if (response.user === "newUser") {
          setIsNewUser(true);
          setStep(3);
        } else {
          setIsNewUser(false);
          setStep(4);

          const userToken = response.data?.[0]?.cust_token;
          localStorage.setItem("token", userToken);
          window.dispatchEvent(new Event("tokenUpdate"));
          setLocalToken(userToken);

          if (setToken) setToken(userToken);

          window.dispatchEvent(new Event("tokenUpdate"));
          closeModal();
        }
      } else {
        toast.error(response?.message || "OTP verification failed.");
      }
    } catch (err) {
      console.error("OTP Verification Error:", err);
      toast.error(
        err.message || "Error verifying OTP. Please try again later."
      );
    }
  };

  const HandlesignUpNewUser = async () => {
    if (!validateFields()) return;
    try {
     
      const response = await signUpNewUser({
        ...userData,
        cust_contact: phone,
      });

      if (response && response.status === 200) {
        toast.success(response.message || "Signup successful!");
        setStep(4);
        localStorage.setItem("token", response.user[0].cust_token);
        if (setToken) setToken(response.user[0].cust_token);
        window.dispatchEvent(new Event("tokenUpdate"));
        closeModal();
      } else {
        toast.error(response?.message || "Signup failed. Please try again.");
      }
    } catch (error) {
      console.error("Signup Error:", error);
      toast.error(error.message || "Error signing up. Please try again later.");
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="loginModal"
        tabIndex="-1"
        aria-labelledby="loginModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="row">
              {/* Left Side */}
              <div className="col-md-5 modal-left text-center">
                <h3 style={{ color: "white" }}> Login/Signup</h3>
                <img src="/assets/images/illunation.webp" alt="Illustration" />
              </div>

              {/* Right Side */}
              <div className="col-md-7 modal-right">
                <div className="modal-header border-0">
                  <h5 className="modal-title" id="loginModalLabel">
                    {step === 1
                      ? "Enter your phone number"
                      : isNewUser
                      ? "Complete Your Profile"
                      : "Enter OTP"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={modalRef}
                  ></button>
                </div>
                <div className="modal-body">
                  {error && <p style={{ color: "red" }}>{error}</p>}

                  {step === 1 ? (
                    <>
                      <div className="mb-3">
                        <label className="form-label">Phone Number</label>
                        <div className="input-group">
                          <span
                            className="input-group-text"
                            style={{ height: "40px" }}
                          >
                            +91
                          </span>
                          <input
                            type="tel"
                            className="form-control"
                            placeholder="Enter your mobile"
                            required
                            value={phone}
                            maxLength={10}
                            onChange={(e) => setPhone(e.target.value)}
                            style={{ height: "100%" }}
                          />
                        </div>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="agreeTerms"
                          checked={isChecked}
                          onChange={() => setIsChecked(!isChecked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="agreeTerms"
                        >
                          I agree to the <a href="#">Terms and Conditions</a> &{" "}
                          <a href="#">Privacy Policy</a>
                        </label>
                      </div>
                    </>
                  ) : isNewUser ? (
                    <>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">First Name *</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter First Name"
                              value={userData.f_name}
                              onChange={(e) =>
                                setUserData({
                                  ...userData,
                                  f_name: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Last Name *</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Last Name"
                              value={userData.l_name}
                              onChange={(e) =>
                                setUserData({
                                  ...userData,
                                  l_name: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Contact No.</label>
                            <input
                              type="tel"
                              className="form-control"
                              placeholder="Contact No."
                              maxLength={10}
                              value={phone}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Alternate Contact
                            </label>
                            <input
                              type="tel"
                              className="form-control"
                              placeholder="Enter Alt Contact"
                              maxLength={10}
                              value={userData.cust_alt_contact}
                              onChange={(e) =>
                                setUserData({
                                  ...userData,
                                  cust_alt_contact: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter Email"
                          value={userData.cust_email}
                          onChange={(e) =>
                            setUserData({
                              ...userData,
                              cust_email: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="agreeTerms"
                          checked={showReferralInput}
                          onChange={() => {
                            setShowReferralInput(!showReferralInput);
                            setShowReferralInput(!showReferralInput);
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="agreeTerms"
                        >
                          I have a referral code
                        </label>
                      </div>

                      {/* Referral Code Input Field */}
                      {showReferralInput && (
                        <div className="mb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your referral code"
                            value={userData.referer_code}
                            maxLength={8}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                referer_code: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <p className="text-muted">
                        We've sent an OTP on your registered number.
                      </p>
                      <p className="text-muted">
                        Phone number: <span className="fw-bold">{phone}</span>{" "}
                        <a href="#" className="text-primary">
                          Edit
                        </a>
                      </p>

                      {/* OTP Inputs */}
                      <div className="d-flex justify-content-between mb-3">
                        {otp.map((digit, index) => (
                          <input
                            key={index}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) => handleChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={(el) => (otpInputRefs.current[index] = el)}
                            className="form-control text-center fw-bold border"
                            style={{
                              width: "45px",
                              height: "45px",
                              fontSize: "20px",
                              color: "#333",
                              borderColor: "#73b734",
                            }}
                          />
                        ))}
                      </div>

                      {/* Resend OTP Timer */}
                      <p className="text-muted text-center">
                        {timer > 0 ? (
                          `Resend OTP in ${timer} seconds`
                        ) : (
                          <a onClick={sendOtp} className="text-primary" style={{cursor:"pointer"}}>
                            Resend OTP
                          </a>
                        )}
                      </p>
                    </>
                  )}
                </div>

                <div className="modal-footer border-0">
                  {step === 1 ? (
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ height: "37px", width: "90px" }}
                      onClick={sendOtp}
                    >
                      Continue
                    </button>
                  ) : isNewUser ? (
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ height: "37px", width: "90px" }}
                      onClick={HandlesignUpNewUser}
                    >
                      Submit
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary "
                      style={{ height: "40px", width: "120px" }}
                      onClick={verifyOtp}
                    >
                      Verify OTP
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Model;
